import { Image, Typography } from "antd";
import React from "react";
import { useParams } from "react-router-dom";

import FlexContainer from "@/components/FlexContainer";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { FALLBACK_IMAGE } from "@/constants";
import { useAppSelector } from "@/hooks/redux";
import {
    CarouselWrapper,
    DocumentItem,
    ImageWrapper,
    StyledCarousel,
    StyledText,
    TaskDescriptionBlock,
    TaskDescriptionText,
} from "@/pages/WorkPlan/ProductCard/Styled";
import { getFileUrl } from "@/utils/file/getFileUrl";

function ProductCard() {
    const { barcode } = useParams();
    const { products } = useAppSelector((state) => state.offline);

    let imagesList = null;

    const value = products?.[barcode]?.params?.image?.value;

    if (Array.isArray(value) && value.length > 0) {
        imagesList = value;
    }

    return products?.[barcode] ? (
        <>
            <Meta title="Profile" />
            <Header title={products?.[barcode]?.name} back />
            <MainContainer>
                {imagesList?.length > 1 ? (
                    <CarouselWrapper>
                        <StyledCarousel draggable arrows>
                            {imagesList?.map((item: string, index: number) => (
                                <Image
                                    key={index}
                                    height="300px"
                                    width="auto"
                                    src={getFileUrl(item)}
                                    fallback={FALLBACK_IMAGE}
                                />
                            ))}
                        </StyledCarousel>
                    </CarouselWrapper>
                ) : (
                    <ImageWrapper>
                        <Image
                            width="auto"
                            height="100%"
                            loading="eager"
                            src={getFileUrl(imagesList?.[0])}
                            fallback={FALLBACK_IMAGE}
                        />
                    </ImageWrapper>
                )}

                <StyledText>Штрихкод: {barcode}</StyledText>
                <TaskDescriptionBlock>
                    {/*<DocumentItem>*/}
                    {/*    <FlexContainer justifyContent="space-between">*/}
                    {/*        <TaskDescriptionText>Ціна</TaskDescriptionText>*/}
                    {/*        <TaskDescriptionText>*/}
                    {/*            {priceList?.[barcode]?.price || "---"} грн*/}
                    {/*        </TaskDescriptionText>*/}
                    {/*    </FlexContainer>*/}
                    {/*</DocumentItem>*/}
                    {products?.[barcode].params &&
                        Object.values(products?.[barcode]?.params)?.map(
                            (item, index) =>
                                item?.paramTag !== "image" &&
                                item?.paramTag !== "description" &&
                                item?.paramTag !== "barcode" ? (
                                    <DocumentItem key={index}>
                                        <FlexContainer justifyContent="space-between">
                                            <TaskDescriptionText>
                                                {item?.paramName}
                                            </TaskDescriptionText>
                                            <TaskDescriptionText>
                                                {typeof item?.value ===
                                                "boolean"
                                                    ? item?.value
                                                        ? "Так"
                                                        : "Ні"
                                                    : item?.value}
                                            </TaskDescriptionText>
                                        </FlexContainer>
                                    </DocumentItem>
                                ) : null,
                        )}
                </TaskDescriptionBlock>
                <TaskDescriptionBlock>
                    <Typography>
                        {products?.[barcode]?.params?.description?.value}
                    </Typography>
                </TaskDescriptionBlock>
            </MainContainer>
        </>
    ) : null;
}

export default ProductCard;
